import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=a036b1a0&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a036b1a0')) {
      api.createRecord('a036b1a0', component.options)
    } else {
      api.reload('a036b1a0', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=a036b1a0&", function () {
      api.rerender('a036b1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25zFodfR0dA13/JS/pricehelp.vue"
export default component.exports